import type { ComponentProps } from "react";

export function Playground(props: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			{...props}
		>
			{" "}
			<path
				fill="currentColor"
				d="M6.21 6.23a.807.807 0 0 1 1.093-.033l4.242 3.763c.723.641.755 1.715.072 2.398l-4.01 4.01-.057.053a.808.808 0 0 1-1.035-.02.696.696 0 0 1-.082-.97l.052-.058 4.01-4.01a.233.233 0 0 0-.01-.343L6.241 7.258a.698.698 0 0 1-.031-1.029Z"
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeWidth={1.5}
				d="M12.401 17.505h6.151"
			/>
		</svg>
	);
}
